// cr 主頁 section4 item

import Image from "next/image";

const CRMediaItem = ({info}) =>{
    return(
        <div
            className={`w-full h-[178px] bg-yellow text-jblack flex flex-shrink-0 py-[40px] gap-x-[44px] box-content usm:flex-col usm:text-center usm:h-full`}
        >
            <div className="img-box h-[178px] w-[178px] rounded-[22px] overflow-hidden usm:m-auto usm:mb-[44px]">
                <Image
                    alt="media_image"
                    width={178}
                    height={178}
                    src={info?.img}
                    className="aspect-square absolute"
                />
            </div>
            <div className="flex flex-col">
                <p className="text-black text-bd6n tracking-[1.3px] umd:text-bd5n">{info?.title}</p>
                <div>
                    <p className="text-black7 text-bd1m text-justify">{info?.content}</p>
                </div>
            </div>
        </div>
    )

};

export default CRMediaItem ;